var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5342 6.46255C11.2469 6.17524 10.7767 6.17524 10.4894 6.46255L8.99317 7.95879L7.50438 6.46255C7.21708 6.17524 6.74692 6.17524 6.45962 6.46255C6.17231 6.74985 6.17231 7.22001 6.45962 7.50731L7.95586 9.00355L6.45962 10.4998C6.17231 10.7871 6.17231 11.2573 6.45962 11.5446C6.59767 11.6826 6.78797 11.761 6.97827 11.761C7.16858 11.761 7.3626 11.6826 7.49693 11.5446L8.99317 10.0483L10.4894 11.5446C10.6275 11.6826 10.8178 11.761 11.0081 11.761C11.1984 11.761 11.3924 11.6826 11.5267 11.5446C11.814 11.2573 11.814 10.7871 11.5267 10.4998L10.0305 9.00355L11.5267 7.50731C11.814 7.22001 11.814 6.74985 11.5267 6.46255H11.5342Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03744 0 0 4.0372 0 9C0 13.9628 4.0372 18 9 18C13.9628 18 18 13.9628 18 9C18 4.0372 13.9628 0 9 0ZM9 16.4549C4.88805 16.4549 1.54481 13.1117 1.54481 8.99976C1.54481 4.88782 4.88805 1.54458 9 1.54458C13.1119 1.54458 16.4552 4.88782 16.4552 8.99976C16.4552 13.1117 13.1119 16.4549 9 16.4549Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.a2f3f31c809e677904501df332d5cef1.svg";
export { ForwardRef as ReactComponent };